import omit from 'lodash/omit';

export const getMenuItem = async (id, menuCategoryId) => {
  if (['-default', '-pagebreak', '-blankline'].includes(id)) {
    return await window.axios
      .request({
        url: '/menu-items/' + id,
        method: 'post',
        headers: {
          'Content-Type': 'application/vnd.api+json',
        },
        data: { menuCategoryId },
      })
      .then((response) => {
        return response.data.data;
      });
  }
  return await window.axios.get('/menu-items/' + id).then(({ data }) => {
    return data;
  });
};

export const getMenuItemsByCategory = async (id) => {
  return await window.axios.get('/menu-items?filter[menu_category_id]=' + id).then(({ status, data }) => {
    if (status === 200) {
      return data;
    }
  });
};

export const storeMenuItem = async (item) => {
  const method = item.id ? 'patch' : 'post';

  return await window.axios
    .request({
      url: '/menu-items/' + (item.id ?? '') + '?include=ingredients',
      method,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { data: omit(item, item.id ? [] : ['id']) },
    })
    .then((response) => {
      return response.data.data;
    });
};

export const deleteMenuItem = async (itemId, moreIds) => {
  return await window.axios
    .delete(`/menu-items/${itemId}`, {
      data: {
        moreIds,
      },
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((data) => {
      return data.data;
    });
};
